<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-rocket"></i></span>
    <h1>Become a Partner</h1>
    <p class="static-subtitle">Join the orderYaa partner network and help businesses run better.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        If you're a consultant, systems integrator, or agency that works with retail, restaurant,
        or wholesale businesses, you can partner with orderYaa to implement, resell, and support
        our ERP &amp; POS platform for your clients.
      </p>

      <h2>Why partner with us</h2>
      <ul>
        <li>Recurring revenue from implementation and support engagements</li>
        <li>Direct access to our product and engineering team</li>
        <li>Co-marketing and referral opportunities</li>
        <li>Early access to new modules and features</li>
      </ul>

      <h2>Who we're looking for</h2>
      <ul>
        <li>Software consultants and system integrators</li>
        <li>Accounting and business advisory firms</li>
        <li>Point-of-sale and hardware resellers</li>
        <li>Agencies already serving retail and hospitality clients</li>
      </ul>

      <h2>How to apply</h2>
      <p>
        Send us a short note about your business and the clients you typically work with, and
        we'll get in touch to discuss the partnership.
      </p>

      <div class="static-cta">
        <a class="btn" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a call to discuss partnering</a>
      </div>
    </div>
  </div>
</section>
